import RplIcon from './Icon.vue'
import RplTextIcon from './TextIcon.vue'
import './icons/index.js'

export { RplIcon }
export { RplTextIcon }
export default RplIcon
